import { displayLocalDateTime } from "utils/helpers";

export const Message = ({
  createdAt,
  creatorId,
  message,
  userData,
  originatorId,
  originatorName,
  admins = [],
  marketers = [],
  schedulers = [],
}) => {
  const time = displayLocalDateTime(createdAt);

  const specialists = [...admins, ...marketers, ...schedulers];
  const you = specialists.find(({ email }) => email === userData?.email);

  const isYourMessage = creatorId === you?.userId;
  const isIncoming = creatorId === originatorId;
  const teamMember = specialists.find(
    ({ userId }) => userId === creatorId && !isYourMessage
  );

  const getSpecialistRoleById = (id) => {
    if (admins.find(({ userId }) => userId === id)) return "Admin";
    if (marketers.find(({ userId }) => userId === id)) return "Marketer";
    if (schedulers.find(({ userId }) => userId === id)) return "Scheduler";
    return null;
  };

  const getMessageAuthorById = (id) => {
    if (id === originatorId) return `${originatorName}, Sender`;

    return isYourMessage
      ? "You"
      : teamMember
      ? [teamMember?.name, getSpecialistRoleById(teamMember.userId)].join(", ")
      : "Team Member";
  };

  return (
    <div
      className={[
        "px-4 flex flex-col justify-start w-full gap-0.5",
        isIncoming ? "items-start" : "items-end",
      ].join(" ")}
    >
      <div className={"text-sm text-gray-900 px-1"}>
        {getMessageAuthorById(creatorId)}
      </div>
      <div
        className={[
          "p-2 rounded-lg shadow-md text-sm",
          isYourMessage && "bg-blue-600 text-white ml-6",
          teamMember && "bg-gray-300 ml-6",
          isIncoming && "bg-cyan-300 mr-6",
        ].join(" ")}
        style={{ whiteSpace: "pre-line" }}
      >
        {message}
      </div>
      <div className={"text-xs px-1 text-gray-600"}>{time}</div>
    </div>
  );
};
